/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'
import CategoryList from './NavigationCategoryList'
import { useCategoryMetaData } from 'src/core'

const propTypes = {
  currentCategory: PropTypes.string,
  currentFaqPageUrl: PropTypes.string,
}

const defaultProps = {
  currentPageUrl: '',
}

const NavigationDropdown = ({ currentCategory, currentFaqPageUrl }) => {
  const categories = useCategoryMetaData()
  const [openList, setOpenList] = useState(false)

  useEffect(() => {
    if (typeof document !== 'undefined') {
      openList
        ? document.body.classList.add('overflow-hidden')
        : document.body.classList.remove('overflow-hidden')
    }
  }, [openList])

  function openCategoryNav(category) {
    return currentCategory === category
  }

  function isCurrentPage(slug) {
    return currentFaqPageUrl === slug
  }

  function getSelectedItem() {
    return !currentFaqPageUrl
      ? currentCategory
      : categories
          .find(item => item.category === currentCategory)
          .categoryData.find(data => data.slug === currentFaqPageUrl).title
  }

  function handleListToggle() {
    setOpenList(!openList)
  }

  function handleOverlayClick() {
    setOpenList(false)
  }

  return (
    <div className="sticky top-0 z-40 -mx-6 bg-primary-lightest lg:hidden">
      <button
        className={`flex justify-between items-center px-6 py-3 w-full text-left text-lg font-semibold shadow-sm outline-none`}
        onClick={handleListToggle}
        aria-haspopup="listbox"
      >
        {getSelectedItem() || 'Select...'}
        <div className="text-secondary">
          <Icon icon="formSelect" className="w-6 h-6 fill-current" />
        </div>
      </button>
      <div
        className={`absolute left-0 right-0 z-20 overflow-scroll scrolling-touch h-screen ${
          openList ? '' : 'hidden'
        }`}
        role="listbox"
        tabIndex="-1"
        onClick={handleOverlayClick}
      >
        <div className="px-6 mb-56 bg-primary-lightest shadow-card">
          <CategoryList
            categories={categories}
            openCategoryNav={openCategoryNav}
            isCurrentPage={isCurrentPage}
            inCategoryPage={!currentFaqPageUrl}
          />
        </div>
      </div>
    </div>
  )
}

NavigationDropdown.propTypes = propTypes
NavigationDropdown.defaultProps = defaultProps

export default NavigationDropdown
